import { Provider } from "@angular/core";
import * as services from "./services";

export function provideNotes(): Array<Provider>
{
    return [
        services.NoteService
    ];
}
